import BaseApi from './base'

class Dashboard extends BaseApi {
  getRealtimeMetrics = () => this.client.get('admin/dashboard/real-time')

  getMonthlyTripStatistics = () =>
    this.client.get('admin/dashboard/monthly-trip-statistics')

  getMonthlyDigitalKeyStatistics = () =>
    this.client.get('admin/dashboard/monthly-rider-keys-statistics')

  getMonthlyRiderStatistics = (params) =>
    this.client.get('admin/dashboard/monthly-rider-statistics', { params })

  getMonthlyRiderSubscriptionsStatistics = () =>
    this.client.get('admin/dashboard/monthly-rider-subscriptions-statistics')

  getMonthlyAlertStatistics = () =>
    this.client.get('admin/dashboard/monthly-pers-alert-statistics')

  getMonthlyPersActivityStatistics = () =>
    this.client.get('admin/dashboard/monthly-pers-activity-statistics')

  getMonthlyDirectVehicleStatistics = () =>
    this.client.get('admin/dashboard/monthly-direct-vehicles-statistics')

  getMonthlyRiderPermanentSharingsStatistics = () =>
    this.client.get(
      'admin/dashboard/monthly-rider-permanent-sharings-statistics'
    )

  getMonthlyRiderTemporarySharingsStatistics = () =>
    this.client.get(
      'admin/dashboard/monthly-rider-temporary-sharings-statistics'
    )

  getMonthlyCompanyStatistics = (params) =>
    this.client.get('admin/dashboard/monthly-company-statistics', { params })

  getCurrentDataCompanyStatistics = () =>
    this.client.get('admin/dashboard/current-company-dashboard-statistics')

  getCurrentRidersStatistics = () =>
    this.client.get('admin/dashboard/current-riders-statistics')

  getRidersDashboardStatistics = () =>
    this.client.get('admin/dashboard/riders-dashboard-statistics')

  getMonthlyManufacturerPersReceptionStatistics = (params) =>
    this.client.get(
      'admin/dashboard/monthly-manufacturer-pers-reception-statistics',
      {
        params
      }
    )

  getMonthlySubcontractorPersReceptionStatistics = (params) =>
    this.client.get(
      'admin/dashboard/monthly-subcontractor-pers-reception-statistics',
      {
        params
      }
    )

  getMonthlyProducedVehiclesStatistics = (params) =>
    this.client.get('admin/dashboard/monthly-produced-vehicles-statistics', {
      params
    })

  getDetailRealtimeAlerts = (params) =>
    this.client.get('admin/dashboard/real-time/alerts/active', { params })
}
export default new Dashboard()
